import React from "react";
import TimerOutlinedIcon from "@mui/icons-material/TimerOutlined";
import useServerCountdown from "../../hooks/useServerCountdown";
import { deadlineLabel, formatCountdown } from "../../utils/groupBasketView";
import { Pill } from "./groupBasketStyles";

/*
 * The basket's active deadline as a pill: "Basket closes in 12:30". The
 * deadline is the server's (`deadlines.active`), counted on the server's
 * clock. At zero it says the server is on it rather than guessing the result.
 */
const GroupBasketCountdown = ({ deadline, serverNow, receivedAt, tone = "dark", label }) => {
  const ms = useServerCountdown({ at: deadline?.at, serverNow, receivedAt });
  if (!deadline?.at || ms === null) return null;
  const text = label || deadlineLabel(deadline.kind);
  return (
    <Pill $tone={tone} role="timer" aria-live="off">
      <TimerOutlinedIcon aria-hidden="true" />
      {ms > 0 ? `${text} ${formatCountdown(ms)}` : "Updating"}
    </Pill>
  );
};

export default GroupBasketCountdown;
